/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_797a00d4"]'><div><div :class='["picker-demo-title"]'>date-time-picker:</div><cube-date-picker :min="(min)" :max="(max)" :value="(value)" :columnCount="(columnCount)"/></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_797a00d4"}'>
.picker-demo-title
  margin-bottom: 8px
.event-params,
.demo-data
  margin-top: 10px
  .key
    margin-bottom: 10px
  .value
    margin-bottom: 20px
    white-space: break-spaces
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_797a00d4"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_797a00d4"}
  /** script content **/
  require("./date-time-picker.mpx.js?isComponent&outputPath=components%2Fdate-time-picker797a00d4%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./date-time-picker.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdate-time-picker797a00d4%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_797a00d4"],
    ctorType: "component",
    outputPath: "components/date-time-picker797a00d4/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-date-picker':getComponent(require("../../../packages/mpx-cube-ui/src/components/date-picker/index.mpx?isComponent&outputPath=components%2Findexc2f4660c%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>